import { Component, EventEmitter, Input, Output, HostBinding } from '@angular/core';
import { Store } from '@ngrx/store';
import { OnboardingCustomSettings } from '../../../store/session/actions/navigation.actions';
import { State } from '../../../store/state.reducer';
import { ClarityConfig } from '../../../config/clarity.config';
import { OnboardingCloseEvent } from 'src/app/constants/onboarding-types.const';

@Component({
  selector: 'cl-auto-screen',
  styleUrls: ['auto-screen.component.scss'],
  template: `
    <ion-grid class="onboarding-content container">
      <ion-row *ngIf="!settings.hideCloseIcon" class="first-row">
        <img class="close-button" src="assets/imgs/close.png" (click)="onClose()"/>
      </ion-row>

      <ion-row class="second-row margin-top-minus-20">
        <p class="page-title blue-heading text-align-center full-width">{{settings.header | translate}}</p>
      </ion-row>

      <ion-row class="third-row">
        <p
          class="page-details blue-heading text-align-center full-width"
          [innerHTML]="settings.body | translate">
        </p>
      </ion-row>

      <ion-row class="fourth-row">
        <ion-col *ngIf="settings.button && settings.actAsConfirm">
          <ion-row *ngIf="settings.link">
            <ion-col size="6" class="ion-text-center">
              <cl-action-button
                label="{{settings.link | translate}}"
                [canClick]="true"
                [square]="true"
                [whiteBg]="true"
                [small]="true"
                (action)="onLinkClick()">
              </cl-action-button>
            </ion-col>
            <ion-col size="6" class="ion-text-center">
              <cl-action-button
                label="{{settings.button | translate}}"
                [canClick]="true"
                [square]="true"
                [small]="true"
                (action)="onButtonClick()">
              </cl-action-button>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="!settings.link">
            <ion-col class="ion-text-center">
              <cl-action-button
                label="{{settings.button | translate}}"
                [canClick]="true"
                (action)="onButtonClick()">
              </cl-action-button>
            </ion-col>
          </ion-row>
        </ion-col>

        <p *ngIf="settings.link && !settings.button"
           class="footer-link orange-heading"
           (click)="onClose()">
          {{settings.link | translate}}
        </p>

        <p *ngIf="settings.link && settings.button && !settings.actAsConfirm"
           class="footer-link footer-double-link orange-heading"
           (click)="onClose()">
          {{settings.link | translate}}
        </p>

        <div class="button-wrapper" *ngIf="settings.button && !settings.actAsConfirm">
          <div class="center-button">
            <cl-action-button
              label="{{settings.button | translate}}"
              [canClick]="true"
              (action)="onClose()">
            </cl-action-button>
          </div>
        </div>
      </ion-row>
    </ion-grid>
  `
})
export class AutoScreenComponent {

  @Input() settings: OnboardingCustomSettings;

  @Output() closeClick = new EventEmitter<OnboardingCloseEvent>();

  constructor(
    public store: Store<State>,
    public config: ClarityConfig
  ) {

  }

  onClose(onboardingCloseEvent?: OnboardingCloseEvent) {
    this.closeClick.emit(onboardingCloseEvent);
  }

  onLinkClick() {
    this.onClose({ isComplete: !Boolean(this.settings.dontCompleteOnLinkClick) });

    if (this.settings.actAsConfirm && this.settings.actionOnLink) {
      this.store.dispatch(this.settings.actionOnLink);
    }
  }

  onButtonClick() {
    this.onClose({ isComplete: !Boolean(this.settings.dontCompleteOnButtonClick) });

    if (this.settings.actAsConfirm && this.settings.callbackOnButton) {
      this.settings.callbackOnButton();
    }

    if (this.settings.actAsConfirm && this.settings.actionOnButton) {
      this.store.dispatch(this.settings.actionOnButton);
    }
  }
}
